<template>
    <section class="hero is-default is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <h3 class="title has-text-grey">DBCleaner</h3>
                    <p class="subtitle has-text-grey">Ingresa para continuar</p>
                    <div class="box">
                        <a :href="signInWithGoogle('/')" class="button">
                            <span class="icon">
                                <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
                                        <path fill="#4285F4" d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z"/>
                                        <path fill="#34A853" d="M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z"/>
                                        <path fill="#FBBC05" d="M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z"/>
                                        <path fill="#EA4335" d="M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z"/>
                                    </g>
                                </svg>
                            </span>
                            <span>Iniciar sesión con Google</span>
                        </a>
                        <a @click="signInWithMicrosoft()" class="button mt-1">
                            <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px">
                                    <path fill="#ff5722" d="M6 6H22V22H6z" transform="rotate(-180 14 14)"/>
                                    <path fill="#4caf50" d="M26 6H42V22H26z" transform="rotate(-180 34 14)"/>
                                    <path fill="#ffc107" d="M26 26H42V42H26z" transform="rotate(-180 34 34)"/>
                                    <path fill="#03a9f4" d="M6 26H22V42H6z" transform="rotate(-180 14 34)"/>
                                </svg>
                            </span>
                            <span>Iniciar sesión con Microsoft</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import logo from '../assets/logo.png'
import keys from '../../oauth2.keys.json'
import con from '../utils/db'

export default {
    name: "SingIn",
    data:()=>({
        logo: logo,
        signInWithMicrosoft: con.signInWithMicrosoft
    }),
    methods:{
        signInWithGoogle(from){
            const rootUrl = keys.web.auth_uri;
            const options = {
                redirect_uri: keys.web.redirect_uris[0],
                client_id: keys.web.client_id,
                access_type: 'offline',
                response_type: 'code',
                prompt: 'consent',
                scope: [
                'https://www.googleapis.com/auth/userinfo.profile',
                'https://www.googleapis.com/auth/userinfo.email',
                ].join(' '),
                state: from,
            };
            const qs = new URLSearchParams(options);
            return `${rootUrl}?${qs.toString()}`;
        }
    }
}
</script>
